import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation UpdateRequestTypePriority($requestTypePriorityID: ID!, $weight: Int!) {
  changeRequestTypePriority(requestTypePriorityID: $requestTypePriorityID, weight: $weight){
    id
    weight
  }
}`;

function updateRequestTypePriority({ id, weight }) {
  return apollo.client.mutate({
    mutation,
    variables: {
      requestTypePriorityID: parseInt(id, 10),
      weight: parseInt(weight, 10),
    },
  }).then((res) => res.data.changeRequestTypePriority);
}

export default updateRequestTypePriority;
